import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { LocalStorageService } from '@app/shared/services/local-storage.service';
import type { UserProfileComponent } from './user-profile.component';

export const userProfileNavigationGuard: CanDeactivateFn<UserProfileComponent> = component => {
  const authService = inject(AuthService);
  if (!authService.currentUser()) return true;
  // A failed token refresh clears the tokens and redirects to sign-in before AuthService's token-loss
  // effect clears `currentUser`; never block (or prompt on) that redirect.
  if (!inject(LocalStorageService).tokens()) return true;
  return component.confirmNavigation();
};
